export default "__VITE_ASSET__zUTMb_fT__"